<template>
  <div
    v-if="
      GET_ACCOUNT_DATA.group_id == 1 ||
        has_perm('create_case') ||
        has_perm('update_case')
    "
  >
    <div>
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">
            <span>{{ $t(addtitle) }}</span>
          </h3>
        </div>

        <div class="box-body">
          <form class="form-horizontal">
            <div class="col-md-12">
              <!-- <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-3 col-md-3 col-lg-3 control-label required"
                    >{{ $t("case.type") }}</label
                  >
                  <div class="col-sm-9 col-md-9 col-lg-9">

                    <v-select
                      class="clear"
                      :options="caseTypeList"
                      v-model="feedbackData.type"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.text)"
                      :placeholder="$t('case.type')"
                    >
                      <template v-slot:option="option">
                        {{ $t(option.text) }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div> -->
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-3 col-md-3 col-lg-3 control-label required"
                    >{{ $t("feedback.apartmentCode") }}</label
                  >
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <v-select
                      class="clear"
                      :options="apartmentList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.text)"
                      v-model="feedbackData.apartmentCode"
                      :placeholder="$t('feedback.apartmentCode')"
                      @option:selected="
                        onChangeApartment(feedbackData.apartmentCode)
                      "
                      :disabled="parseInt($route.params.id) !== 0"
                    >
                      <template v-slot:option="option">
                        {{ option.text }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-3 col-md-3 col-lg-3 control-label required"
                    >{{ $t("feedback.customerName") }}</label
                  >
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <v-select
                      class="clear"
                      :options="customerList"
                      v-model="feedbackData.customerName"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.full_name)"
                      :filter="onSearchUserVueSelect"
                      :placeholder="$t('feedback.customerName')"
                      :disabled="parseInt($route.params.id) !== 0"
                    >
                      <template #list-header>
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">{{ $t("customer.fullname") }}</th>
                              <th scope="col">{{ $t("customer.email") }}</th>
                            </tr>
                          </thead>
                        </table>
                      </template>
                      <template v-slot:option="option">
                        <div
                          style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                        >
                          <div style="width: 50%; word-break: break-all;">
                            {{ $t(option.full_name) }}
                          </div>
                          <div style="width: 50%">
                            {{ $t(option.email) }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                    $t("feedback.processor")
                  }}</label>
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <!-- <v-select
                      class="clear"
                      :options="departmentList"
                      :reduce="data => data.id"
                      label="name"
                      :placeholder="$t('feedback.apartmentCode')"
                    >
                      <template v-slot:option="option">
                        {{ option.name }}
                      </template>
                    </v-select> -->
                    <v-select
                      class="clear"
                      :options="departmentList"
                      :reduce="data => data.id"
                      :getOptionLabel="option => $t(option.name)"
                      v-model="feedbackData.departmentId"
                      :placeholder="$t('feedback.processor')"
                      @option:selected="
                        getFeedbackSubjectList(feedbackData.departmentId)
                      "
                    >
                      <template v-slot:option="option">
                        {{ option.name }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <!-- <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                    $t("case.assignto")
                  }}</label>
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <v-select
                      class="clear"
                      :options="staffs"
                      v-model="feedbackData.assignTo"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.full_name)"
                      :filter="onSearchUserVueSelect"
                      :placeholder="$t('case.assignto')"
                    >
                      <template #list-header>
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">{{ $t("customer.fullname") }}</th>
                              <th scope="col">{{ $t("customer.email") }}</th>
                            </tr>
                          </thead>
                        </table>
                      </template>
                      <template v-slot:option="option">
                        <div
                          style="display: flex; padding-top: 5px; padding-bottom: 5px; border-bottom: 1px solid #ccc"
                        >
                          <div style="width: 50%; word-break: break-all;">
                            {{ $t(option.full_name) }}
                          </div>
                          <div style="width: 50%">
                            {{ $t(option.email) }}
                          </div>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div> -->

              <div
                class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15"
                v-if="parseInt($route.params.id) !== 0"
              >
                <div class="form-group">
                  <label
                    class="col-sm-3 col-md-3 col-lg-3 control-label required"
                    >{{ $t("case.status") }}</label
                  >
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <v-select
                      :options="feedbackStatusList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => $t(option.text)"
                      v-model="feedbackData.status"
                      :placeholder="$t('case.status')"
                      :clearable="false"
                      disabled
                    >
                      <template v-slot:option="option">
                        {{ $t(option.text) }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <!-- <div
                class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15"
                v-if="feedbackData.departmentId"
              >
                <div class="form-group">
                  <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                    $t("feedback.config.chooseSubject")
                  }}</label>
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <v-select
                      :options="feedbackSubjectList"
                      :reduce="data => data.value"
                      :getOptionLabel="option => option.text"
                      v-model="feedbackData.subject"
                      :placeholder="$t('feedback.config.chooseSubject')"
                      :clearable="false"
                      @option:selected="onSelectSubject"
                      :disabled="parseInt($route.params.id) !== 0"
                    >
                      <template v-slot:option="option">
                        {{ option.text }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div> -->
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label
                    class="col-sm-3 col-md-3 col-lg-3 control-label required"
                    >{{ $t("case.casetitle") }}</label
                  >
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model="feedbackData.feedbackTitle"
                      :disabled="parseInt($route.params.id) !== 0"
                    />
                  </div>
                </div>
              </div>
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <label class="col-sm-3 col-md-3 col-lg-3 control-label">{{
                    $t("feedback.content")
                  }}</label>
                  <div class="col-sm-9 col-md-9 col-lg-9">
                    <b-form-textarea
                      v-model="feedbackData.content"
                      :placeholder="$t('feedback.content')"
                      rows="3"
                      max-rows="6"
                      :disabled="parseInt($route.params.id) !== 0"
                    />
                  </div>
                </div>
              </div>
              <!-- chat box -->
              <!-- <div
                v-if="parseInt($route.params.id) !== 0"
                class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15"
              >
                <div class="row">
                  <div
                    class="col-md-12 bg-white"
                    style="padding: 15px; background: #dddddd;"
                  >
                    <div class="chat-message">
                      <ul class="chat">
                        <div
                          v-for="(item, index) in feedbackChatList"
                          :key="item + index"
                        >
                          <li v-if="item.is_user_login" class="right clearfix">
                            <span class="chat-img pull-right">
                              <img
                                :src="
                                  item.url_avatar !== null
                                    ? item.url_avatar
                                    : noAvatarDefault
                                "
                                alt="User Avatar"
                              />
                            </span>
                            <div class="chat-body clearfix">
                              <div class="header">
                                <small class="text-muted"
                                  ><i class="fa fa-clock-o"></i
                                  > {{ item.date_created }}</small
                                >
                                <strong class="primary-font pull-right">{{
                                  item.full_name
                                }}</strong>
                              </div>
                              <p>
                                {{ item.content }}
                              </p>
                            </div>
                          </li>
                          <li v-else class="left clearfix">
                            <span class="chat-img pull-left">
                              <img
                                :src="
                                  item.url_avatar !== null
                                    ? item.url_avatar
                                    : noAvatarDefault
                                "
                                alt="User Avatar"
                              />
                            </span>
                            <div class="chat-body clearfix">
                              <div class="header">
                                <strong class="primary-font">{{
                                  item.full_name
                                }}</strong>
                                <small class="pull-right text-muted"
                                  ><i class="fa fa-clock-o"></i>
                                  {{ item.date_created }}</small
                                >
                              </div>
                              <p>
                                {{ item.content }}
                              </p>
                            </div>
                          </li>
                        </div>
                      </ul>
                    </div>
                    <div class="chat-box bg-white">
                      <div class="input-group">
                        <input
                          class="form-control border no-shadow no-rounded"
                          :placeholder="$t('common.inputContent')"
                          v-model="feedbackChatContent"
                          v-on:keyup.enter="onSaveFeedbackChat"
                        />
                        <span class="input-group-btn">
                          <button
                            class="btn btn-success no-rounded"
                            type="button"
                            @click="onSaveFeedbackChat"
                          >
                            {{ $t("common.send") }}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
              <!--  -->
              <div class="col-ms-12 col-md-12 col-lg-8 margin-bottom-15">
                <div class="form-group">
                  <div class="col-ms-12 col-md-12 col-lg-12">
                    <label for="">{{ $t("banner.image") }}</label>
                    <button
                      type="button"
                      class="btn btn-primary btn-xs pull-right"
                      @click="onOpenInputSelectFile(imgList.length + 1)"
                    >
                      <span class="btn-label">
                        <i class="fa fa-plus"></i>
                      </span>
                      {{ $t("common.addNewImg") }}
                    </button>
                  </div>
                  <div class="col-ms-12 col-md-12 col-lg-12">
                    <div :style="`overflow: auto; max-height: 270px;`">
                      <div
                        class="apartment-img-block"
                        v-for="(item, index) in imgList"
                        :key="item + index"
                      >
                        <img
                          id="apartment-img-id"
                          class="apartment-type-class img-responsive"
                          :src="item.url"
                          alt="apartment-img"
                          style="cursor: pointer"
                          @click="onOpenImg(item.url)"
                        />
                        <div class="img-action">
                          <span
                            style="color: #006ad4"
                            class="action-button"
                            @click="onOpenInputSelectFile(index)"
                            ><small>{{ $t("common.update") }}</small></span
                          >
                          <span
                            style="color: #f2404d"
                            class="action-button"
                            @click="onclickRemoveImg(index)"
                            ><small>{{ $t("common.delete") }}</small></span
                          >
                        </div>
                      </div>
                      <input
                        class="img-upload-input"
                        :id="`upload-img-input`"
                        type="file"
                        accept="image/*"
                        @change="handleClick"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </form>
          <div class="col-md-12">
            <hr>
            <div
              v-if="parseInt($route.params.id) !== 0"
              class="col-ms-12 col-md-12 col-lg-12 margin-bottom-15"
            >
              <div class="row">
                <div class="col-sm-12 col-md-5 col-lg-4">
                  <label for="" style="margin-bottom: 15px;">{{
                    $t("feedback.feedbackProcessingStatus")
                  }}</label>
                  <TimeLineVue
                    :timeline-items="timelineItems"
                    :message-when-no-items="messageWhenNoItems"
                    customFromDateTime="DD/MM/YYYY"
                    uniqueYear
                    uniqueTimeline
                  />
                </div>
                <div class="col-sm-12 col-md-7 col-lg-8">
                  <incident-report 
                    :feedbackId="feedbackData.id"
                    :feedbackStatus="feedbackData.status"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="onCancelCase"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            v-if="
              (GET_ACCOUNT_DATA.group_id == 1 ||
                has_perm('create_case') ||
                has_perm('update_case')) &&
              (feedbackData.status !== feedbackStatusEnum.DONE &&
              feedbackData.status !== feedbackStatusEnum.CANCELED)
            "
            class="btn btn-labeled btn-success pull-right"
            @click="onSaveCase"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
      <detail-feedback-history 
        v-show="parseInt($route.params.id) !== 0" 
        :feedbackId="feedbackData.id"
       />
      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      ></lte-core-alert>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import { mapGetters, mapActions } from "vuex";
// import moment from "moment";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import constantsData from "@/lib/constantsData";
import configuration from "@/lib/config";
import axios from "axios";
import TimeLineVue from "@/components/TimeLineVue/Timeline.vue";
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";
//
import DetailFeedbackHistory from "./DetailFeedbackHistory";
import IncidentReport from "./IncidentReport";

export default {
  name: "CaseAdd",
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,
    TimeLineVue,
    DetailFeedbackHistory,
    IncidentReport
  },
  data() {
    return {
      addtitle: "case.addnew",
      isLoading: false,
      staffs: [],
      feedbackData: {
        id: 0,
        feedbackTitle: null,
        content: null,
        customerName: null,
        apartmentCode: null,
        departmentId: null,
        assignTo: null,
        status: 1,
        subject: null
      },

      caseTypeList: [],
      customerList: [],
      apartmentList: [],
      feedbackStatusList: constantsData.feedbackStatusList,
      departmentList: [],
      feedbackSubjectList: [],
      feedbackSubjectSelectText: null,
      noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
      noAvatarDefault: configuration.imgUrlConfig.noAvatarDefault,
      apartmentTypeImgList: [],
      imgUploadIndex: 0,
      imgList: [],
      imgUploadData: {
        url: null,
        size: null,
        file: null
      },
      media_server: {
        domain: "",
        token: ""
      },
      feedbackChatList: [],
      feedbackChatContent: null,
      messageWhenNoItems: "There are not items",
      timelineItems: [
        {
          from: "",
          title: this.$t("feedback.statusList.done"),
          color: "#DDDDDD",
          value: feedbackStatusEnum.DONE
        },
        {
          from: "",
          title: this.$t("feedback.statusList.doing"),
          color: "#DDDDDD",
          value: feedbackStatusEnum.IN_PROGRESS
        },
        {
          from: "",
          title: this.$t("feedback.statusList.received"),
          color: "#DDDDDD",
          value: feedbackStatusEnum.RECEIVED
        },
        {
          from: "",
          title: this.$t("feedback.statusList.new"),
          color: "#DDDDDD",
          value: feedbackStatusEnum.CREATE
        }
      ],
      colorDots: "#2da1bf",
      feedbackStatusEnum: feedbackStatusEnum
    };
  },

  watch: {
    GET_APARTMENT_LIST_NO_PAGE_DATA: function() {
      this.apartmentList = [];
      let data = this.GET_APARTMENT_LIST_NO_PAGE_DATA;
      data.forEach(apartment => {
        let item = {
          value: apartment.id,
          text: apartment.apartment_code
        };
        this.apartmentList.push(item);
      });
    },
    GET_DEPARTMENT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_NO_PAGE_DATA;
      this.departmentList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          name: value.name
        };
        this.departmentList.push(item);
      });
    },
    GET_TOKEN_UPLOAD_DATA: function() {
      let data = this.GET_TOKEN_UPLOAD_DATA;
      this.media_server.domain = data.domain;
      this.media_server.token = data.token;
    },
    GET_FEEDBACK_CHAT_LIST_DATA: function() {
      let data = this.GET_FEEDBACK_CHAT_LIST_DATA;
      this.feedbackChatList = [];
      data.forEach(e => {
        let item = {
          id: e.id,
          full_name: e.user_info.full_name,
          content: e.content,
          position: e.user_info.position,
          is_user_login: e.is_user_login,
          date_created: utils.formatSqlDate(e.date_created, null, "HH:mm DD-MM-YYYY"),
          url_avatar: utils.getCleanStringValue(e.user_info.url_avatar)
        };
        this.feedbackChatList.push(item);
      });
    }
  },

  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_NO_PAGE_DATA",
      "GET_DEPARTMENT_LIST_NO_PAGE_DATA",
      "GET_TOKEN_UPLOAD_DATA",
      "GET_FEEDBACK_CHAT_LIST_DATA"
    ]),
    account_fullname: function() {
      return `${this.GET_ACCOUNT_DATA.lastname} ${this.GET_ACCOUNT_DATA.firstname}`;
    }
  },

  methods: {
    updateTimeLine: function(dataList, feedbackStatus) {
      let data = this.timelineItems;
      let result = [];
      // update time line have status canceled
      let elBeforeCancel = null
      let isCancel = dataList.findIndex(x => x.status === feedbackStatusEnum.CANCELED);
      // is element done
      let isDone = dataList.findIndex(x => x.status === feedbackStatusEnum.DONE);
      for (let i = 0; i < data.length; i++) {
        // get element before canceled
        if (isCancel !== -1) {
          elBeforeCancel = dataList[isCancel - 1]
        }
        let index = dataList.findIndex(x => x.status === data[i].value);
        if (index !== -1) {
          let dateFormat = new Date(dataList[index].date_created);
          // this.timelineItems[i].color = this.colorDots;
          // this.timelineItems[i].from = dataFormat;
          let item = {
            from: dateFormat,
            title: data[i].title,
            color: this.colorDots,
            value: data[i].value
          };
          // update color element status is cancel
          if (elBeforeCancel && elBeforeCancel.status === data[i].value) {
            item.color = 'red'
          }
          result.push(item);
        } else {
          let item = {
            from: "",
            title: data[i].title,
            color: data[i].color,
            value: data[i].value
          };
          if (isDone !== -1) {
            let dateFormat = new Date(dataList[isDone].date_created);
            item = {
              from: dateFormat,
              title: data[i].title,
              color: this.colorDots,
              value: data[i].value
            };
          }
          result.push(item);
        }
      }

      this.timelineItems = result;
    },
    onSearchUserVueSelect: function(options, search) {
      let resultSearch = options.filter(
        x =>
          x.full_name.toLowerCase().includes(search.toLowerCase()) ||
          x.email.toLowerCase().includes(search.toLowerCase())
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    onCancelCase: function() {
      this.$router.push({
        name: "CaseList"
      });
    },
    validateData: function() {
      let validateResult = "OK";
      for (let key in this.feedbackData) {
        if (
          key != "customerName" &&
          key != "apartmentCode" &&
          key != "feedbackTitle" &&
          key != "content"
        ) {
          //
        } else {
          if (utils.isEmptyString(this.feedbackData[key])) {
            validateResult =
              this.$t("case.ErrorNotification") +
              " " +
              this.$t("feedback." + key);
            break;
          }
        }
      }
      return validateResult;
    },
    onSaveCase: function() {
      this.isLoading = true;
      let result = this.validateData();
      if (result == "OK") {
        this.feedbackData.openby = this.GET_ACCOUNT_DATA.id;
        let data = {
          id: this.feedbackData.id,
          customerId: this.feedbackData.customerName,
          assignTo: this.feedbackData.assignTo,
          apartmentId: this.feedbackData.apartmentCode,
          status: this.feedbackData.status,
          title: this.feedbackData.feedbackTitle,
          content: this.feedbackData.content,
          subject: this.feedbackData.subject,
          department: this.feedbackData.departmentId,
          imgUrlList: this.imgList
        };
        if (data.id !== 0) {
          this.UPDATE_FEEDBACK(data).then(
            function() {
              this.$router.push({
                name: "CaseList"
              });
              this.isLoading = false;
              this.SUCCESS_TOAST();
            }.bind(this)
          ).catch(
            function(error) {
              this.isLoading = false;
              this.ERROR_TOAST();
            }.bind(this)
          );
        } else {
          this.CREATE_FEEDBACK(data).then(
            function() {
              this.$router.push({
                name: "CaseList"
              });
              this.isLoading = false;
              this.SUCCESS_TOAST();
            }.bind(this)
          ).catch(
            function(error) {
              this.isLoading = false;
              this.ON_SHOW_TOAST();
            }.bind(this)
          );
        }
      } else {
        this.isLoading = false;
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      }
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getUserInApartment: function(apartmentId) {
      let filter = {
        params: {
          apartmentId: apartmentId
        }
      };
      this.GET_USER_IN_APARTMENT_LIST(filter).then(
        function(res) {
          this.customerList = [];
          let data = res;
          data.forEach(value => {
            let item = {
              value: value.id,
              full_name: value.last_name + " " + value.first_name,
              email: value.email
            };
            this.customerList.push(item);
          });
        }.bind(this)
      );
    },
    onChangeApartment: function(value) {
      this.getUserInApartment(value);
    },
    getFeedbackSubjectList: function(departmentId) {
      let filter = {
        params: {
          departmentId: departmentId
        }
      };
      this.GET_FEEDBACK_SUBJECT_LIST(filter).then(
        function(res) {
          let data = res;
          this.feedbackSubjectList = [];
          data.forEach(value => {
            let item = {
              value: value.id,
              text: value.subject
            };
            this.feedbackSubjectList.push(item);
          });
        }.bind(this)
      );
    },
    onSelectSubject: function(data) {
      this.feedbackData.feedbackTitle = data.text;
    },
    // handle upload img
    addAndUpdateImgList: function() {
      if (this.imgUploadIndex > this.imgList.length) {
        let item = {
          url: this.imgUploadData.url
        };
        this.imgList.push(item);
      } else {
        let imgListElement = this.imgList[this.imgUploadIndex];
        imgListElement.url = this.imgUploadData.url;
      }
      // if (this.imgUploadIndex > this.imgList.length) {
      //   // let item = {
      //   //   id: 0,
      //   //   url: this.imgUploadData.url
      //   // };
      //   this.imgList.push(this.imgUploadData.url);
      // } else {
      //   // let imgListElement = this.imgList[this.imgUploadIndex];
      //   this.imgList[this.imgUploadIndex] = this.imgUploadData.url;
      // }
    },
    onOpenInputSelectFile: function(index) {
      this.imgUploadIndex = index;
      $(`#upload-img-input`).val("");
      $(`#upload-img-input`).click();
    },
    onclickRemoveImg: function(index) {
      this.imgList.splice(index, 1);
    },
    handleClick: async function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.imgUploadData.size = files[0].size;
      await this.uploadImgFunction();
      await this.addAndUpdateImgList();
    },
    getResultFile: function(file) {
      let vm = this;
      vm.imgUploadData.file = file;
    },
    uploadImgFunction: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        let formData = new FormData();
        formData.append("file", this.imgUploadData.file);
        formData.append("directory", "homeMobileApp");
        formData.append("forceOverride", true);
        await axios({
          method: "POST",
          timeout: 6000,
          url: this.media_server.domain + "/api/v1/upload/",
          data: formData,
          headers: { Authorization: `JWT ${this.media_server.token}` }
        })
          .then(
            function(res) {
              let imgUrl = res.data.domain + res.data.url;
              this.imgUploadData.url = imgUrl;
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    onOpenImg: function(url) {
      window.open(url);
    },
    getFeedbackChatList: function(feedbackId) {
      let filter = {
        params: {
          feedbackId: feedbackId
        }
      };
      this.GET_FEEDBACK_CHAT_LIST(filter);
    },
    onSaveFeedbackChat: function() {
      if (utils.isEmptyString(this.feedbackChatContent)) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.inputContent"),
          styleType: "danger"
        });
      } else {
        let data = {
          feedbackId: this.feedbackData.id,
          content: this.feedbackChatContent
        };
        this.CREATE_FEEDBACK_CHAT(data)
          .then(
            function(res) {
              this.getFeedbackChatList(this.feedbackData.id);
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getMaintenanceTypeList: function() {
      this.GET_MAINTENANCE_TYPE_LIST();
    },
    getAssetList: function() {
      let filter = {
        params: {
          // isGetApartmentAsset: "True"
        }
      };
      this.GET_ASSET_LIST_V2(filter);
    },
    getUserList: function() {
      this.GET_USER_LIST();
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_CASE_TYPE_LIST",
      "GET_STAFF_LIST",
      "CREATE_FEEDBACK",
      "UPDATE_FEEDBACK",
      "GET_FEEDBACK_DETAIL",
      // "GET_CUSTOMER_LIST",
      "GET_APARTMENT_LIST",
      "GET_DEPARTMENT_LIST",
      "GET_USER_IN_APARTMENT_LIST",
      "GET_FEEDBACK_SUBJECT_LIST",
      "GET_TOKEN_UPLOAD",
      "GET_FEEDBACK_CHAT_LIST",
      "CREATE_FEEDBACK_CHAT",
      "GET_MAINTENANCE_TYPE_LIST",
      "GET_ASSET_LIST_V2",
      "GET_USER_LIST"
    ])
  },

  async mounted() {
    $(document).ready(function() {
      $(".wish-icon i").click(function() {
        $(this).toggleClass("fa-heart fa-heart-o");
      });
    });
    this.GET_TOKEN_UPLOAD();
    await this.GET_STAFF_LIST().then(
      function(res) {
        let staffList = res.data;
        let staffs = [];
        staffList.forEach(data => {
          let full_name = `${data.last_name} ${data.first_name}`;
          let item = {
            value: data.id,
            full_name: full_name,
            email: data.email
          };
          staffs.push(item);
        });
        this.staffs = staffs;
      }.bind(this)
    );
    await this.GET_CASE_TYPE_LIST().then(
      function(res) {
        this.caseTypeList = [];
        let data = res.data;
        data.forEach(value => {
          let item = {
            id: value.id,
            text: value.name
          };
          this.caseTypeList.push(item);
        });
      }.bind(this)
    );
    // customer list
    // this.GET_CUSTOMER_LIST().then(
    //   function(res) {
    //     this.customerList = [];
    //     let data = res.data;
    //     data.forEach(value => {
    //       let item = {
    //         id: value.id,
    //         full_name: value.last_name + " " + value.first_name,
    //         email: value.email
    //       };
    //       this.customerList.push(item);
    //     });
    //   }.bind(this)
    // );
    // apartment
    let apartmentFilter = {
      params: {
        asset: "asset"
      }
    };
    this.isLoading = true;
    await this.GET_APARTMENT_LIST(apartmentFilter).then(
      function() {
        this.isLoading = false;
      }.bind(this)
    ).catch(
      function() {
        this.isLoading = false;
      }.bind(this)
    );
    // department
    await this.GET_DEPARTMENT_LIST();
    // //////////////////////////////
    // Add or Update data
    // //////////////////////////////
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.addtitle = "case.modify";
      this.caseId = parseInt(id);
      // this.getFeedbackChatList(id);
      this.getMaintenanceTypeList()
      this.getAssetList()
      this.getUserList()
      await this.GET_FEEDBACK_DETAIL({ id: id }).then(
        async function(res) {
          let data = res;
          this.feedbackData.id = data.id;
          this.feedbackData.feedbackTitle = data.title;
          this.feedbackData.customerName = data.customer;
          this.feedbackData.apartmentCode = data.apartment;
          await this.getUserInApartment(this.feedbackData.apartmentCode);
          this.feedbackData.assignTo = data.assign_to;
          this.feedbackData.status = data.status;
          this.feedbackData.departmentId = data.department;
          await this.getFeedbackSubjectList(this.feedbackData.departmentId);
          this.feedbackData.subject = data.subject;
          this.feedbackData.content = data.content;
          this.imgList = data.feedback_img_list;
          this.updateTimeLine(data.feedback_history, data.status);
        }.bind(this)
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr.new1 {
  width: 90%;
}
input[type="file"] {
  display: none;
}

.date-format {
  padding-top: 7px;
  margin-bottom: 0;
}

.case-format {
  width: 330%;
  margin-left: -16px;
}

.asset-format {
  width: 330%;
  margin-left: -16px;
}

.date-input-format {
  width: 304px;
}

@media (max-width: 789px) and (min-width: 320px) {
  .case-format {
    margin-top: 0px;
    width: 107%;
  }
  .asset-format {
    margin-top: 0px;
    width: 107%;
  }
}

/* label.required:not(:empty):after, */
/* .field-header.required:after { */
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}

.margin-bottom-15 {
  padding-bottom: 15px;
}

/*  */
.feedback-img-item {
  width: 100%;
  max-width: 150px;
  max-height: 200px;
  object-fit: contain;
}

.feedback-img-class {
  margin: auto;
  text-align: center;
}

.apartment-img-block {
  display: inline-block;
}
.apartment-type-class {
  margin: auto;
  width: 100%;
  max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  padding: 5px;
}

.img-upload-input {
  display: none;
  z-index: -9999;
}

/*  */
body {
  padding-top: 0;
  font-size: 12px;
  color: #777;
  background: #f9f9f9;
  font-family: "Open Sans", sans-serif;
  margin-top: 20px;
}

.bg-white {
  background-color: #fff;
}

small,
.small {
  font-size: 85%;
}

.chat-message {
  padding: 30px 20px 30px;
  max-height: 300px;
  overflow: auto;
}

.chat {
  list-style: none;
  margin: 0;
}

.chat-message {
  background: #dddddd;
}

.chat li img {
  width: 45px;
  height: 45px;
  border-radius: 50em;
  -moz-border-radius: 50em;
  -webkit-border-radius: 50em;
}

img {
  max-width: 100%;
}

.chat-body {
  padding-bottom: 20px;
}

.chat li.left .chat-body {
  margin-left: 70px;
  background-color: #fff;
}

.chat li .chat-body {
  position: relative;
  font-size: 11px;
  padding: 10px;
  border: 1px solid #f1f5fc;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  -moz-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.chat li .chat-body .header {
  padding-bottom: 5px;
  border-bottom: 1px solid #f1f5fc;
}

.chat li .chat-body p {
  margin: 0;
}

.chat li.left .chat-body:before {
  position: absolute;
  top: 10px;
  left: -8px;
  display: inline-block;
  background: #fff;
  width: 16px;
  height: 16px;
  border-top: 1px solid #f1f5fc;
  border-left: 1px solid #f1f5fc;
  content: "";
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
}

.chat li.right .chat-body:before {
  position: absolute;
  top: 10px;
  right: -8px;
  display: inline-block;
  background: #fff;
  width: 16px;
  height: 16px;
  border-top: 1px solid #f1f5fc;
  border-right: 1px solid #f1f5fc;
  content: "";
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
}

.chat li {
  margin: 15px 0;
}

.chat li.right .chat-body {
  margin-right: 70px;
  background-color: #fff;
}

.chat-box {
  /*
  position: fixed;
  bottom: 0;
  left: 444px;
  right: 0;
*/
  background: #dddddd;
  padding: 15px;
  border-top: 1px solid #eee;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
}

.primary-font {
  color: #3c8dbc;
}

a:hover,
a:active,
a:focus {
  text-decoration: none;
  outline: 0;
}
/*  */
.chat-message::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.chat-message::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.chat-message::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.chat-message::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/CaseAddV2.vue